<fc-outlined-select
  [required]="required"
  [label]="label"
  [control]="control"
  [searchFn]="searchDeadlineContracts"
></fc-outlined-select>
